export class TyreSeason {
    TyreSeasonId: number;
    Description: string;
}
